import { getBasicSingleInitialState, getBasicSingleReducerSlice } from '@probatix/common/utils/service'

import { UsersSingleState } from '@probatix/common/services/RTKServices/patients/index.model'
import { STATE_KEY } from '../userService.constants'

export const slice = getBasicSingleReducerSlice<UsersSingleState>(getBasicSingleInitialState(), STATE_KEY)

export default slice.reducer

